// extracted by mini-css-extract-plugin
module.exports = {"SeparatorWrapper":"Separator_SeparatorWrapper__yDMzF","SeparatorContainer":"Separator_SeparatorContainer__MMCSm","Line":"Separator_Line__3WGL5"};